<template lang="pug">
  div
    .heading--section Securities Borrowing and Lending (SBL) Income Predictor
    Loading(:isLoading="isDataLoading", type="bar")
      DataTable.mt-4(:records="sbls", :headers="headers")
      
      .text--color_grey.pad_t--15.text--size_13
        strong IMPORTANT NOTICE:
        
        .pad_t--5
          ul.list--unordered.list--unordered_default
            li Lending fee is calculated daily based on the previous day closing price of the loaned securities and on 365-day/year.  Securities’ price and fee rate may fluctuate based on market conditions and supply and demand for the securities, which will affect potential earnings.
            li Retail securities lending is a non-principal protected product and is not insured by Perbadanan Insurans Deposit Malaysia.

</template>


<script>
import requestHandlers from '../mixins/requestHandlers';

import DataTable from './DataTable';
import Loading from './Loading';

export default {
  mixins: [requestHandlers],

  components: { 
    DataTable,
    Loading
  },

  data() {
    return {
      sbls: [],
      headers: [
        {
          id: 'counter',
          text: 'Stock',
          sortable: true,
          type: 'counter',
          colWidth: 10,
        },
        {
          id: 'quantity',
          text: 'Quantity',
          sortable: true,
          type: 'number',
          filter: 'round',
          colWidth: 10,
          colAlignment: 'center',
        },
        {
          id: 'currentPrice',
          text: 'Current Price',
          sortable: true,
          type: 'number',
          filter: 'decimal',
          colWidth: 10,
          colAlignment: 'center',
        },
        {
          id: 'marketValue',
          text: 'Market Value',
          sortable: true,
          type: 'number',
          filter: 'round',
          colWidth: 10,
          colAlignment: 'center',
        },
        {
          id: 'lendingRate',
          text: 'Lending Rate (%)',
          sortable: true,
          type: 'number',
          filter: 'decimal',
          colWidth: 10,
          colAlignment: 'center',
        },
        {
          id: 'estimatedMonthyIncome',
          text: 'Estimated Monthly Income',
          sortable: true,
          type: 'number',
          filter: 'round',
          colWidth: 15,
          colAlignment: 'center',
        },
      ]
    }
  },

  computed: {
  },

  methods: {
    FETCH_RECORDS() {
      this.REQUEST_INIT();
      this.$axios.get('/Sbl')
      .then(response => {
        if(response.status === 200) {
          this.sbls = response.data;
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    }
  },

  created() {
    this.FETCH_RECORDS();
  },
}
	
</script>



<style lang="scss">

</style>